import { Property } from 'springroll';
import KeyboardJS from 'keyboardjs';

export interface IDisposable {
    dispose():void;
}

export class Disposable implements IDisposable
{
    private cleanup: () => void;

    constructor(cleanup: () => void)
    {
        this.cleanup = cleanup;
    }

    /**
     * Performs the cleanup method - single use. Calling again will not perform cleanup again.
     */
    public dispose()
    {
        this.cleanup?.();
        this.cleanup = null;
    }

    public destroy()
    {
        this.dispose();
    }

    public static fromPropertySubscription<T>(property: Property<T>, cb: (value: T, prev?: T) => void)
    {
        property.subscribe(cb);
        return new Disposable(() => property.unsubscribe(cb));
    }

    public static fromKey(key: string|string[], down: (e?:KeyboardJS.KeyEvent)=>void, up?: (e?:KeyboardJS.KeyEvent)=>void)
    {
        const context = KeyboardJS.getContext();

        KeyboardJS.bind(key, down, up);
        return new Disposable(() => {
            const prev = KeyboardJS.getContext();
            // have to remove listeners from the context they exist in
            KeyboardJS.setContext(context);
            KeyboardJS.unbind(key, down, up);
            // restore previous context
            KeyboardJS.setContext(prev);
        });
    }
}

export class DisposableGroup extends Disposable
{
    private group: IDisposable[];

    constructor(...group: IDisposable[])
    {
        super(() => {
            for (const d of this.group)
            {
                d.dispose();
            }
            this.group = null;
        });
        this.group = group;
    }

    public add(...group: IDisposable[])
    {
        if (this.group)
        {
            this.group.push(...group);
        }
    }
}
